import React, { Component } from "react";
import { compose, withState } from "recompose";
import { DragNDrop } from "components/generic/kit";
import { readFile } from "core/utils";
import styled from "styled-components";
import Avatar from "./Avatar";
import { Field } from "formik";

const Wrap = styled.div`
  position: relative;
  margin: 0 auto;
  transition: background-color 0.1s;
  width: 150px;
`;

const Image = styled.div`
  width: 150px;
  height: 150px;
  background-size: cover;
  background-position: center;
  border-radius: 50%;
  ${({ src }) =>
    src &&
    `
    background-image: url(${src});
  `};
`;

class UploadPhoto extends Component {
  componentWillReceiveProps({ file }) {
    const { tempPhoto, setTempPhoto } = this.props;
    if (tempPhoto && !file) {
      return setTempPhoto(null);
    }
    if (file) {
      readFile(file).then(base64 => {
        if (tempPhoto !== base64) {
          setTempPhoto(base64);
        }
      });
    }
  }

  render() {
    const {
      photo,
      tempPhoto,
      setFile,
      file,
      filename,
      setFilename,
      setTempPhoto,
      ...props
    } = this.props;
    return (
      <Wrap>
        <label className="dib">
          <Field
            name={props.name}
            render={({
              field,
              form: { touched, errors, values, setValues }
            }) => {
              const error = errors[field.name];
              const isDirty = touched[field.name];
              return (
                <DragNDrop
                  onDrop={files => {
                    const file = files[0];

                    setFile(file);
                    setFilename(file.name);
                    setValues({
                      ...values,
                      [field.name]: file
                    });
                  }}
                >
                  {({ isOver }) => (
                    <React.Fragment>
                      <Avatar isOver={isOver}>
                        <Image src={tempPhoto || photo} />
                      </Avatar>
                      <input
                        ref={input => {
                          this.textInput = input;
                        }}
                        error={isDirty && error}
                        value=""
                        type="file"
                        accept="image/*"
                        filename={filename}
                        className="o-0 absolute"
                        onChange={e => {
                          const file = e.target.files[0];
                          setFile(file);
                          setFilename(file.name);
                          setValues({
                            ...values,
                            [field.name]: file
                          });
                        }}
                      />
                    </React.Fragment>
                  )}
                </DragNDrop>
              );
            }}
          />
        </label>
      </Wrap>
    );
  }
}

export default compose(
  withState("tempPhoto", "setTempPhoto", null),
  withState("file", "setFile", null),
  withState("filename", "setFilename", null)
)(UploadPhoto);



// WEBPACK FOOTER //
// ./src/components/generic/form/formik/PhotoUpload/index.js